
import { ElFormItem } from 'element-plus';
import { defineComponent } from 'vue';

export default defineComponent({
    components: {
        ElFormItem
    }
});
